/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { icpUsdRateGetApiV3IcpUsdRate } from "../../funcs/icpUsdRateGetApiV3IcpUsdRate.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$icpUsdRateGetApiV3IcpUsdRate: ToolDefinition = {
  name: "icp-usd-rate-get-api-v3-icp-usd-rate",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await icpUsdRateGetApiV3IcpUsdRate(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
